import { Dayjs } from 'dayjs';
import moment from 'moment';
import { DATE_FORMATS } from '$Utils/date-utils';
// TODO - this should probably live in $Utils, but it was breaking Jest tests there.
// Ensure that we're reformatting any date strings or date/DayJS objects to a MomentJS object,
// as that is what the AntD components expect.
export const formatMomentDate = (value) => {
    if (!value && typeof value === 'string')
        return;
    // If value is null, undefined, or already a Moment object, let it pass through. Otherwise, convert it.
    if (value && !moment.isMoment(value)) {
        // Moment wants to be called with formats specified as the 2nd arg, otherwise it will complain.
        // Reformat value to Date first to avoid any invalid formats. use Coordinated Universal Time for consistency.
        return moment(typeof value === 'object' && value instanceof Dayjs
            ? value.toDate()
            : new Date(value), DATE_FORMATS).utc();
    }
    return value;
};
